import { isPlainObject } from "lodash";
import { FieldValues } from "react-hook-form";

export function extractInitialValuesFromRecord<
  TRecord extends Record<string, unknown>,
  TFormValues extends FieldValues
>(record: TRecord, initialValues: TFormValues): TFormValues {
  return Object.entries(initialValues).reduce((acc, [key, initialValue]) => {
    if (isPlainObject(initialValue) && typeof initialValue === "object") {
      if (!record[key]) return { ...acc, [key]: initialValue };

      return {
        ...acc,
        [key]: extractInitialValuesFromRecord(record[key] as Record<string, unknown>, initialValue as TFormValues),
      };
    }

    if (Array.isArray(initialValue)) {
      if (!record[key]) return { ...acc, [key]: initialValue };

      return {
        ...acc,
        [key]: (record[key] as Record<string, unknown>[]).map((record, index) =>
          isPlainObject(initialValue[index]) ? extractInitialValuesFromRecord(record, initialValue[index]) : record
        ),
      };
    }

    if (
      (record[key] === null || record[key] === undefined) &&
      (typeof initialValue === "string" || typeof initialValue === "boolean")
    ) {
      return { ...acc, [key]: initialValue };
    }

    return { ...acc, [key]: record[key] };
  }, {} as TFormValues);
}
